import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchGameConfigDataData, FetchGameConfigParams } from '../../api/gameConfigData';

export const fetchGameConfigDataAction = createAsyncThunk(
  'assets/config',
  (params: FetchGameConfigParams) => fetchGameConfigDataData(params)
);